// extracted by mini-css-extract-plugin
module.exports = {"content":"blogCard_content__6DXAB","subContent":"blogCard_subContent__2DvHQ","btnSeeMore":"blogCard_btnSeeMore__2JKAW","column":"blogCard_column__mb1S3","btn":"blogCard_btn__1wOQA","textGradient":"blogCard_textGradient__2aLoR","title":"blogCard_title__AcfGj","text":"blogCard_text__2mhnp"};
    if(module.hot) {
      // 1744882532409
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  